<template>
<div class="SearchCohortDiv">
  <div class="container-fluid">
    <div class="row margin-Top-2Perc">
      <div class="col-md-1 col-lg-1 font-size-18px margin-left0Point3Perc padding-right-0Perc margin-top-2px">
        Search
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 width-34Point2Perc padding-left-12px margin-right-1Point1Perc">
        <div class="form-group margin-bottom-0px">
          <div class="icon-addon addon-lg">
            <input type="text" class="form-control background-gray border-rounded" v-model="enteredCohortNameInSearch" autocomplete="off"/>
            <label class="glyphicon glyphicon-search"></label>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-lg-2 font-size-18px left-border width-14Point5Perc padding-Left-2Point1Perc text-align-left">
        <button type="button" class="btn gray-border white-BG margin-auto margin-Top-1Perc" v-on:click="updateHideCreateCohortOverlayFlagOnBtnClick($event)">+ Create New</button>
      </div> 
      <div class="col-md-2 col-lg-2 font-size-18px width-14Point5Perc padding-left-0px text-align-left">
      </div> 
    </div>
    <div class="row vertical-align margin-Top-2Perc">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 font-size-18px text-align-right margin-top-2px">
        Associate with:
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-align-left">
        <button type="button" class="btn gray-border white-BG width-100Perc" @click="performUserClickAction($event, 'associate_leaps_goal')">LEAPS Goal</button>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-align-left">
        <button type="button" class="btn gray-border white-BG width-100Perc" @click="performUserClickAction($event, 'associate_leaps_action')">LEAPS Action</button>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-align-left">
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-align-left">
      </div>
      <div class="col-xs-3 col-sm-1 col-md-1 col-lg-1 padding-left-12px margin-right-1Point1Perc">
      </div>
    </div><!-- end of row -->
    <associate-cohort-leaps-action-overlay v-if="showAssociateGroupLeapsActionOverlay" @updateValues="updateValueInParent"></associate-cohort-leaps-action-overlay>
    <associate-cohort-leaps-challenge-overlay v-if="showAssociateGroupLeapsChallengeOverlay" @updateValues="updateValueInParent"></associate-cohort-leaps-challenge-overlay>
    <create-cohort-overlay v-if="!hideCreateCohortOverlay" @updateFlag="updateHideCreateCohortOverlayFlag" @showSpinner='updateShowSpinnerFlag'></create-cohort-overlay>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>   
  </div>
</div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import CreateCohortOverlay from '@/components/CreateCohortOverlay'
import AssociateCohortLeapsChallengeOverlay from '@/components/group/AssociateCohortLeapsChallengeOverlay'
import AssociateCohortLeapsActionOverlay from '@/components/group/AssociateCohortLeapsActionOverlay'
export default {
  created: function () {
    this.readQueryParam()
  },
  data: function () {
    return {
      hideCreateCohortOverlay: true,
      enteredCohortNameInSearch: null,
      showAssociateGroupLeapsChallengeOverlay: false,
      showAssociateGroupLeapsActionOverlay: false,
      showSpinner: false
    }
  },
  name: 'SearchCohortDiv',
  methods: {
    readQueryParam: function () {
      const showAssociateGroupLeapsChallengeOverlay = this.$route.query.openAssGoalOverlay
      this.$store.state.hightLightOptionExplictly = true
      if (showAssociateGroupLeapsChallengeOverlay !== undefined && showAssociateGroupLeapsChallengeOverlay !== 'undefined' && showAssociateGroupLeapsChallengeOverlay !== null && showAssociateGroupLeapsChallengeOverlay !== 'null' && showAssociateGroupLeapsChallengeOverlay !== '') {
        this.showAssociateGroupLeapsChallengeOverlay = showAssociateGroupLeapsChallengeOverlay
        this.$store.state.isOverlayVisible = true
      }
    },
    performUserClickAction: function (event, operationName) {
      switch (operationName) {
        case 'associate_leaps_goal':
          this.showAssociateGroupLeapsChallengeOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'associate_leaps_action':
          this.showAssociateGroupLeapsActionOverlay = true
          this.$store.state.isOverlayVisible = true
          break
      }
    },
    updateValueInParent (values) {
      this.showAssociateGroupLeapsChallengeOverlay = false
      this.showAssociateGroupLeapsActionOverlay = false
      this.$store.state.isOverlayVisible = false
      this.$emit('refreshData', true)
    },
    updateHideCreateCohortOverlayFlag (newValue) {
      // AK: If user pressed X and after Creating Successfully Group
      this.hideCreateCohortOverlay = newValue
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = false
    },
    findBy: function (list, value, column) {
      return list.filter(function (item) {
        // return item[column].includes(value)
        // return item[column].indexOf(value) !== -1
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    },
    updateHideCreateCohortOverlayFlagOnBtnClick ($event) {
      // AK: Open Create Group overlay on Create Group Overlay
      this.hideCreateCohortOverlay = false
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = true
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    }
  },
  computed: {
    CohortListValue: {
      get: function () {
        return this.$store.state.cohortList
      }
    }
  },
  watch: {
    enteredCohortNameInSearch: function () {
      if (this.enteredCohortNameInSearch !== null) {
        this.$emit(
          'searchResult',
          this.findBy(
            this.CohortListValue,
            this.enteredCohortNameInSearch,
            'CohortName'
          )
        )
      } else {
        this.$emit('searchResult', this.CohortListValue)
      }
    }
  },
  components: {
    'create-cohort-overlay': CreateCohortOverlay,
    'associate-cohort-leaps-challenge-overlay': AssociateCohortLeapsChallengeOverlay,
    'associate-cohort-leaps-action-overlay': AssociateCohortLeapsActionOverlay,
    'loader': Loader
  }
}
</script>
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red {
  background-color: red;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-0Perc {
  margin-top: 0%;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-4Perc {
  margin-top: 4%;
}
.margin-Top-3Point5Perc {
  margin-top: 3.5%;
}
.margin-Top-8Perc {
  margin-top: 8%;
}
.margin-bottom-0Perc {
  margin-bottom: 0%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-left-0Perc {
  margin-left: 0%;
}
.margin-left0Point3Perc {
  margin-left: .3%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-left-3Perc {
  margin-left: 3%;
}
.margin-left-4Perc {
  margin-left: 4% !important;
}
.margin-left-5Perc {
  margin-left: 5%;
}
.margin-left-6Perc {
  margin-left: 6%;
}

.margin-left-9Perc {
  margin-left: 9%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-2Point1Perc {
  padding-left: 2.1% !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-20px {
  font-size: 20px;
}
.background-gray {
  background-color: #ddd;
}

.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}
.font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-34Point2Perc {
  width: 34.2%;
}
.margin-auto {
  margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Perc {
  padding-right: 0% !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.left-border {
    border-left: 1px solid #aaa;
}
.padding-Left-2Point6Perc {
    padding-left: 2.6% !important;
}
.padding-Left-5Point8Perc {
    padding-left: 5.8% !important;
}
.Padding-left-32px {
  padding-left: 32px !important;
}
.width-69Perc {
  width: 69% !important;
}
.width-12Point5Perc{
  width:12.5%;
}
.padding-left-12px{
  padding-left:12px;
}
.padding-left-0px{
  padding-left: 0px;
}
.width-1Perc{
  width:1%;
}
.margin-top-2px{
  margin-top:2px;
}
.margin-right-9px{
  margin-right:9px;
}
.width-14Point5Perc{
  width:14.5%;
}
.margin-right-1Point1Perc{
  margin-right: 1.1%;
}
</style>





// WEBPACK FOOTER //
// src/components/SearchCohorts.vue